export const setUser = (userObj) => {
    localStorage.setItem("user", JSON.stringify(userObj))
}

export const getUser = () => {
    return JSON.parse(localStorage.getItem('user'));
}